import { useContext } from 'react';
import { DraftPreviewContext } from '.';
export const useDraftPreview = () => {
    const context = useContext(DraftPreviewContext);
    if (!context) {
        throw new Error('useDraftPreview must be used as a child to <DraftPreviewProvider>');
    }
    return context;
};
